module.exports = __webpack_public_path__ + "img/safety-plan.7212b6eb.png";